export default "__VITE_ASSET__9ZtMdHz2__"